const palette = {
  primary: {
    A100: '#E6E7EC',
    A200: '#B0B4C3',
    A300: '#8A90A5',
    A400: '#545D7C',
    A500: '#333D63',
    A600: '#000D3C',
    A700: '#000C37',
    main: '#000D3C',
    A800: '#00092B',
  },
  secondary: {
    A100: '#FFCEB0',
    A200: '#FFB78A',
    A300: '#FF9654',
    A400: '#FF8133',
    A500: '#FF6200',
    A600: '#E85900',
    main: '#FF6200',
    A700: '#B54600',
    A800: '#8C3600',
  },
  transition: {
    A100: '#000D3C',
    A200: '#333D63',
    A300: '#545D7C',
    A400: '#8A90A5',
    A500: '#FF6200',
    A600: '#FF8133',
    A700: '#000D3C',
  },
  gray: {
    A100: '#F2F4F7',
    A200: '#EAECF0',
    A300: '#D0D5DD',
    A400: '#98A2B3',
    A500: '#667085',
    main: '#667085',
    A600: '#475467',
    A700: '#344054',
    A800: '#101828',
  },
  success: {
    A100: '#EEFFED',
    A200: '#D5FBD3',
    A300: '#A9F8AF',
    A400: '#7BEC8E',
    main: '#58D97A',
    A600: '#28C160',
    A700: '#1DA55C',
    A800: '#148A57',
  },
  error: {
    A100: '#FFF1E8',
    A200: '#FEE9DC',
    A300: '#FECDBA',
    A400: '#FDAB97',
    main: '#FC8B7D',
    A600: '#FB5752',
    A700: '#D73B44',
    A800: '#B4293C',
  },
  info: {
    A100: '#DDEFFF',
    A200: '#C9E3FB',
    A300: '#95C7F7',
    A400: '#5E9FE9',
    main: '#3579D3',
    A600: '#0148B7',
    A700: '#00379D',
    A800: '#002983',
  },
  warning: {
    A100: '#FFFAEB',
    A200: '#FFF5CE',
    A300: '#FFE79C',
    A400: '#FFD66C',
    main: '#FFC647',
    A600: '#FFAB0A',
    A700: '#DB8B07',
    A800: '#B76D05',
  },
  text: {
    highlight: '#EC7000',
    emphasis: '#003B70',
    main: '#323232',
  },
  contrast: {
    A500: '#1B3572',
    A600: '#1B3060',
    A700: '#18284D',
    A800: '#090D17',
  },
};

export default palette;
